export enum OperacionEnum {
    create = 1,
    update = 2,
    delete = 3,
    clone = 4,
    updateLista = 5    
}
